<template>
  <div class="wlive">
    
    <!-- <div class="live-fixed-head">
        <div class="header">
            <div class='header-wrap'>
                <div class='header-box'>
                    <a :href="isCanGoIndex?'/':'javascript:void(0)'" v-show="isShowLogo"><img :src="logourl" alt></a>
                    <div>
                        <a class="user">
                            <span @click="appoint">预约直播</span>
                        </a>
                        <a class="user">
                            <span @click="about">关于我们</span>
                        </a>
                        <el-popover trigger="hover" placement="top" width="160">
                            <div class="wlive-pr-code-upload padding-20">
                                <canvas id="qrccode-canvas"></canvas>
                                <div class="pr-code-text">微信扫一扫生成海报</div>
                            </div>
                            <a class="user" slot="reference"><span>生成海报</span></a>
                        </el-popover>
                    </div>
                </div>
            </div>
        </div>      
    </div> -->

    <div class="banner mt75">
      <div class="image pr">
        <img class="radius6" :src="subjectMsg.coverurl" alt width="100%" height="100%">
        <span class="d-see-count pa"><i class="el-icon-view icon"></i> {{subjectMsg.viewcount}}</span>
      </div>
      <div class="text">
        <div class="suntitle">{{subjectMsg.title}}</div>
        <div class="info mt20">
          <span class="mr20">{{subjectMsg.livebegintime}}</span>
          <span>{{subjectMsg.statusname}}</span>
        </div>
      </div>
      <div class="pc-ins-content tc">
        <div class="ins-title mb20">活动简介</div>
        {{subjectMsg.content}}
      </div>
      <div class="tab">
        <span
          v-for="(item,index) in menuList"
          :key="item.innerid"
          @click="checkMenu(item,index)"
          :class="item.innerid==menuId && !is_media ? 'activity' :''"> {{item.columnname}}</span>
        <span @click="mediaReport" v-show="has_mediaReport_status"  :class="{activity:is_media}">媒体报道</span>
      </div>
    </div>
    <!--循环产生各自的div-->
    <template v-for="(menuitem,index) in menuList" >
      <div :key="menuitem.innerid" v-show="menuitem.innerid===menuId" >
        <div v-if="!has_mediaReport">
          <!--图文直播-->
          <template v-if='menuitem.columntype===1'>
            <div class="image-list animated fadeInUp">
              <div >
                <div class="image-item" v-for="(item,idx) in menuitem.contentlist" :key="item.id">
                  <div class="time"><span>{{item.datetime}}</span></div>
                  <div  v-bind:class="['liver',item.isLike ? 'liked-color':'']" @click="addLike(item,idx,index)">
                    <span v-bind:class="item.isLike ? 'liked':''"></span>{{item.praisecount>1000 ? '1000+' : item.praisecount}}
                  </div>
                  <div v-viewer="{ url: 'large',loading: true,title: 'alt',loop: true,navbar:false,title:false}">
                    <div class="detail-btm" :class="item.imgNum===0 ? 'img0': ''" v-if="item.imgNum===0" v-html="item.content"></div>
                    <div class="detail-btm" :class="item.imgNum===1 ? 'img1': ''" v-if="item.imgNum===1" v-html="item.content"></div>
                    <div class="detail-btm" :class="item.imgNum===2 ? 'img2': ''" v-if="item.imgNum===2" v-html="item.content"></div>
                    <div class="detail-btm" :class="item.imgNum>2 ? 'img3': ''" v-if="item.imgNum>2" v-html="item.content" ></div>
                  </div>
                </div>
              </div>
              
              <div class="no-result"  v-show="!menuitem.contentlist || menuitem.contentlist.length<=0">
                <span :style="{marginLeft:subjectMsg.status === 0 ?'-48px':'-40px'}">{{subjectMsg.status === 0 ? '直播还未开始':'暂无数据'}}</span>
              </div>
            </div>
          </template>

          <!--海报-->
          <template v-if='menuitem.columntype===2'>
            <div class="animated fadeInUp" v-viewer="{ url: 'large',loading: true,title: 'alt',loop: true,navbar:false,title:false}">
              <template v-if="menuitem.contentlist && menuitem.contentlist.length > 0">
                  <div class="poster-wrap">
                    <div class="image-item" v-for="(item) in menuitem.contentlist" :key="item.innerid" >
                      <!--<img :preview='menuitem.innerid' :src="item.posterurl" :large="item.posterurl" alt >-->
                      <img :src="item.posterurl_s" :large="item.posterurl" alt="tem.id" >
                    </div>
                    <div class="image-item" style="height:0"></div>
                    <div class="image-item" style="height:0"></div>
                  </div>
              </template>
              <div class="no-result" v-show="!menuitem.contentlist || menuitem.contentlist.length<=0">
                <span :style="{marginLeft:subjectMsg.status === 0 ?'-48px':'-40px'}">{{subjectMsg.status === 0 ? '直播还未开始':'暂无数据'}}</span>
              </div> 
            </div>
          </template>

          <!--图文信息-->
          <template v-if='menuitem.columntype===3'>
            <div class="image-list animated fadeInUp">
                <div >
                  <div class="image-item" v-for="(item) in menuitem.contentlist" :key="item.innerid">
                    <div class="text-item"><div class="title" v-html="item.content"></div>
                  </div>
                  </div>
                </div>
                <div class="no-result" v-show="!menuitem.contentlist || menuitem.contentlist.length<=0">
                  <span>{{subjectMsg.status === 0 ? '直播还未开始':'暂无数据'}}</span>
                </div> 
              </div>
          </template>
        </div>
        

        <!-- 媒体报道 -->
        <div class="media-report animated fadeInUp" v-if='has_mediaReport'>
          <div class="wrap">
            <div class="media-item" v-for="item in mediaList" :key='item.innerid'>
              <div class="content"><a :href="item.mediaurl">{{item.subject}}</a></div>
              <div class="time"><span>{{item.medianame}}</span>{{item.datetime}}</div>
            </div>
          </div>
        </div>
      </div>
    </template>

    
    <!-- 预约 -->
    <div class="appoint-wrap" v-show="isShowLive"></div>
    <div class="dialog-cont live-dailog" v-show="isShowLive">
      <div class="logo-div tc">
        <img class="dialog-logo" src="@/common/images/leveing/web/1@2x.png" alt="" />
      </div>
      <div class="tc media-tit">预约直播</div>
      <el-form class='user-info-form' :model='userLiveInfo' ref='userLiveInfo' :rules="rules">
        <el-form-item prop='name'>
          <img src='@/common/images/leveing/live-detail/user.png' class='img-icon'/>
          <el-input v-model.trim='userLiveInfo.name'  placeholder='您的姓名' clearable class='user'></el-input>
        </el-form-item>
        <el-form-item prop='phone'>
           <img src='@/common/images/leveing/live-detail/phone.png' class='img-icon'/>
          <el-input v-model.number='userLiveInfo.phone' maxlength='11'  placeholder='您的电话' clearable class='phone'></el-input>
        </el-form-item>
        <el-form-item>
           <img src='@/common/images/leveing/live-detail/company.png' class='img-icon'/>
          <el-input v-model.trim='userLiveInfo.company'  placeholder='您的公司' clearable class='d_company'></el-input>
        </el-form-item>
        <el-form-item class='my-textarea pr'>
           <img src='@/common/images/leveing/live-detail/demand.png' class='img-icon'/>
          <el-input v-model.trim='userLiveInfo.reqinfo' type='textarea'  placeholder='您的需求' clearable class='demand'></el-input>
          <!-- <i class="pa el-icon-edit"></i> -->
        </el-form-item>
        <el-form-item style="height:40px">
            <img src='@/common/images/leveing/live-detail/code.png' class='img-icon'/>
          <el-input v-model='userLiveInfo.code' class='my-small-inp code' placeholder='验证码' ></el-input>
          <label class="code-qr-img" @click="getCode">
            <img :src="code_url">
          </label>
        </el-form-item>
        <el-form-item>
          <el-button type='primary' @click='saveUserLive("userLiveInfo")'  :loading='isLoadingSave' class="ybtn">开启预约</el-button>
        </el-form-item>
      </el-form>
      <div class="close"><img class="dialog-logo" src="@/common/images/leveing/web/cancel-icon.png" alt=""  @click="isShowLive=false"/></div>
    </div>

    <div class="appoint-wrap-success" v-show="isShowLiveSuccss"></div>
      <div class="dialog-cont-success dialog-cont live-dailog" v-show="isShowLiveSuccss">
        <div class="logo-div tc">
          <img class="dialog-logo" src="@/common/images/leveing/web/1@2x.png" alt="" />
        </div>
        <div class="success-icon"><img class="" src="@/common/images/leveing/web/success-icon.png" alt="" /></div>
        <div class="success-text">预约成功</div>
        <div class="success-footer">我们会尽快查看您的信息！</div>
        <div class="phone"> 如有疑问请咨询客服：<span>13066904312</span></div>
        <div class="cancel-icon"> <img class="dialog-logo" src="@/common/images/leveing/web/cancel-icon.png" alt=""  @click="closeClick"/></div>
      </div>
  </div>
</template>

<script>
import {
    getLiveInfo,
    getLiveInfoByPage,
    getEndInfo,
    getPendingInfo,
    getColumnList,
    uploadPraiseinfo,
    saveUserLiveInfo
} from "api/web-app";
import Vue from 'vue'
import {mapActions, mapGetters} from 'vuex'
import {getQueryParams} from 'common/js/tools'
import { getCode} from "api/leveingLogin";
import { setTimeout } from 'timers';
// import QRCode from "qrcode";
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer, {
  defaultOptions: {
    url: 'data-source',
    loading: true,
    title: 'alt',
    loop: true
  }
})
export default {
  components:{
    // navMenu
  },
  data() {
    return {
      coverurl: "",
      menuList: [],
      currentpage: 1,
      pagesize: 10,
      viewcount: "",
      livebegintime: "",
      title: "",
      activityid: "",
      status: "",
      contentList: [], //图文
      detailType: 1, //类型,
      menuId:'',//菜单id
      liveinnerid: "",
      columnnamenum: "",
      isShowLogo:false,
      xidx: "",
      typeInnerid:'',
      livestatusText: "",
      logourl: require("@/common/images/leveing/web/web_logo.png"),
      isCanGoIndex:true,//是否能跳转到首页
      timestap: Date.parse(new Date()),
      is_reloadWindow: false,
      is_disabled:true,
      id: 0,
      tabIdx: 0,
      latestid: 0,
      loadingMore: true,
      reesultText:'',
      detailLisText:'',
      leveingId:'',//直播id
      qrCode:'',//验证码
      timer:null,//定时器
      refeshtimes:30000,//刷新时间
      pagesizetext: 10,//图文每页记录
      pagesizeposter:16,//海报每页记录
      userLiveInfo:{
        innerid:this.id,//直播id
        name:'',//姓名
        phone:'',//电话
        reqinfo:'',//需求
        company:'',//公司
        code:'',//验证码
        clienttype:'1',//移动端2,pc1
      },
      code_url:'',
      subjectMsg:{
        posterurl:'',//全屏banner
        coverurl:'',//banner图
        title:'',//主标题
        content:'',//介绍
        statusname:'',//主题状态
        livebegintime:'',//开始时间
        viewcount:0,//浏览量
        status:'',// 0未开始  10进行中   30已结束 100已删除
      },
      rules:{
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到20 个字符', trigger: 'blur' }
        ],
        phone:[
          {required: true, message: '请输入您的电话', trigger: 'blur'},
          { type: 'number', message: '电话号码必须为数字值',trigger: 'blur'}
        ],
        code:[
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ]
      },
      isShowLive:false,
      isLoadingSave:false,
      isShowLiveSuccss:false,
      has_mediaReport:false, //媒体报道,
      is_media:false,
      has_mediaReport_status:false,
      mediaList:[],
      canvas: {}
    };
  },
  created() {
    this.getBannerAndMenu()
  },
  methods: {
    createQrc () {  // 创建移动端二维码
    //   let url = window.location.origin + '/m/livePoster?innerid=' + this.$route.query.innerid
    //   QRCode.toCanvas(this.canvas, url, (error) => {
    //     if (error) {
    //       console.log(error)
    //     } else {
    //       console.log('success')
    //     }
    //   })
    },
    //获取banner，主标题及菜单
    getBannerAndMenu(){
        let innerid = getQueryParams().innerid || this.$routr.query.innerid;
        this.leveingId = innerid
        let param = {
          innerid:innerid
        }
        let that = this
        window.localStorage.setItem('innerid',innerid)

        this.setLoading(true)
        getColumnList({
            data: param,
            success: data => {
                this.setLoading(false)
                if (data.code == '000') {
                    // this.$previewRefresh()
                    let datainfo = data.data
                    this.subjectMsg = {
                        posterurl: datainfo.posterurl,
                        coverurl: datainfo.coverurl,
                        title: datainfo.subject,
                        statusname: datainfo.statusname,
                        content: datainfo.content,
                        livebegintime: datainfo.livebegintime,
                        viewcount: datainfo.viewcount,
                        status: datainfo.status
                    }
                    this.has_mediaReport = datainfo.medialist && datainfo.medialist.length? true:false;
                    this.has_mediaReport_status = datainfo.medialist && datainfo.medialist.length? true:false;
                    this.mediaList= datainfo.medialist && datainfo.medialist.length ? datainfo.medialist:[]
                    this.isShowLogo=true
                    if(datainfo.logourl){
                        this.logourl = datainfo.logourl
                        this.isCanGoIndex = true;//不能跳转到首页
                    }else{
                        this.isCanGoIndex = true;//跳转到首页
                    }
                    let list = datainfo.columnlist
                    list.map(m =>{
                        m.ischeck = false
                        if(m.columntype==1 || m.columntype==3){
                        m.pageSize = that.pagesizetext
                        }
                        else if(m.columntype==2){
                        m.pageSize = that.pagesizeposter
                        }
                        else{
                        m.pageSize = 10
                        }
                        m.currentpage = 1;//默认加载数据，改成1
                        m.loadmore=1//是否还可以加载更多
                        m.isloadingmoredata=0//当前是否是正在获取更多数据
                        if(m.contentlist && m.contentlist.length>0){
                            m.latestid = m.contentlist[0].id
                            m.minid=m.contentlist[m.contentlist.length-1].id
                            that.contentList = m.contentlist;
                            if (m.columntype === 1){
                                // that.$previewRefresh();
                                that.getImg();
                                m.contentlist = that.contentList;
                            }
                        }
                        else{
                            m.latestid=0
                            m.minid=0
                            that.contentList = []
                        }                    
                    })
                    list[0].ischeck = true
                    this.menuList = list;
                    this.is_media=false;
                    this.menuId = this.menuList[0].innerid
                    this.checkMenu(list[0],0,false)
                    document.title=this.subjectMsg.title
                } else {
                    this.$message.error(data.msg)
                }
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })

    },    
    //根据菜单的itm，index以及相关属性获取栏目内容数据
    getMenuContent(itm, idx,isinterval,localrefreshtimes){
        let that = this,
            param = {
            innerid: itm.innerid
        }
      //**********未开始
      if (this.subjectMsg.status === 0) {
        // console.log('未开始')
        this.setLoading(true)
        getPendingInfo({
            data: param,
            success: data => {
                this.setLoading(false)
                if (data.code == '000') {
                    this.contentList = data.data.content;
                    this.menuList[idx].contentlist = this.contentList;
                    this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                    this.reload = data.data.reload;
                } else {
                    this.$message.error(data.msg)
                }
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })

      }
      else if (this.subjectMsg.status === 10) {
        param.latestid = this.menuList[idx].latestid;

        // this.setLoading(true)
        getLiveInfo({
            data: param,
            success: data => {
                this.setLoading(false)
                if (data.code == '000') {
                                  
                    if (data.data.reloadwindow === 1) {
                        this.$router.go(0)
                        return
                    }
                    if (itm.columntype === 1 || itm.columntype === 2) {
                        // this.$previewRefresh();
                        if (data.data.content.length > 0) {
                            this.contentList = data.data.content;
                            this.getImg();
                            if (!this.menuList[idx].contentlist) {
                            this.menuList[idx].contentlist = this.contentList;
                            } 
                            else {
                            for (var i = this.contentList.length - 1; i >= 0; i--) {
                                this.menuList[idx].contentlist.splice(0,0,this.contentList[i]);
                            }
                            }
                            this.menuList[idx].latestid = this.contentList[0].id;                  
                            this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                            this.reload = data.data.reload;
                        } else {
                        this.contentList = [];
                        }
                    }
                    else{
                        // this.$previewRefresh();
                        this.contentList = data.data.content;
                        this.getImg();
                        this.menuList[idx].contentlist = this.contentList;
                        this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                        this.reload = data.data.reload;
                    }
                } else {
                    this.$message.error(data.msg)
                }
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })

      }
      else if (this.subjectMsg.status === 30) {
        param.pagesize = itm.pageSize;
        if (itm.columntype === 3) {
          param.currentpage = 1;
        }
        else{
          param.currentpage = itm.currentpage + 1;
        }

        this.setLoading(true)
        getEndInfo({
            data: param,
            success: data => {
                this.setLoading(false)
                if (data.code == '000') {
                    
                    if (itm.columntype === 3) {
                    this.contentList = data.data.content;
                    this.menuList[idx].contentlist = this.contentList;
                    this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                    this.reload = data.data.reload;
                    this.menuList[idx].isloadingmoredata = 0;
                    }
                    else{
                    // this.$previewRefresh();
                    if (data.data.content.length > 0) {
                        this.contentList = data.data.content;
                        this.getImg();
                        if (!this.menuList[idx].contentlist) {
                        this.menuList[idx].contentlist = this.contentList;
                        } else {
                        for (var i = 0; i < this.contentList.length; i++) {
                            this.menuList[idx].contentlist.push(this.contentList[i]);
                        }
                        }
                        if (data.data.pageinfo.pagecount <=this.menuList[idx].currentpage) {
                        this.menuList[idx].loadmore = 0;
                        } else {
                        this.menuList[idx].loadmore = 1;
                        this.menuList[idx].currentpage =this.menuList[idx].currentpage + 1;
                        }
                    } else {
                        this.menuList[idx].loadmore = 0;
                    }
                    this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                    this.menuList[idx].isloadingmoredata = 0;
                    }
                } else {
                    this.$message.error(data.msg)
                }
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
      }
      if(isinterval==1){
        this.timer = setInterval(function() {
              that.getMenuContent(itm, idx,0,0);
            }, localrefreshtimes);
      }
    },
    //获取直播中的状态上拉分页数据
    getMenuContentByPullOnMore(itm, idx){
        let param = {
            innerid: itm.innerid,
            curminid:itm.minid,
            datacount:itm.pageSize
        }
        this.setLoading(true)
        getLiveInfoByPage({
            data: param,
            success: data => {
                this.setLoading(false)
                if (data.code == '000') {

                    if (data.data.reloadwindow === 1) {
                        this.$router.go(0);
                        return;
                    }
                    // this.$previewRefresh();
                    if (data.data.content.length > 0) {
                        this.contentList = data.data.content;
                        this.getImg();
                        if (!this.menuList[idx].contentlist) {
                            this.menuList[idx].contentlist = this.contentList;
                        } 
                        else {
                            for (var i = 0; i < this.contentList.length; i++) {
                                this.menuList[idx].contentlist.push(this.contentList[i]);
                            }
                        }
                        if (data.data.content.length <this.menuList[idx].pagesize) {
                            this.menuList[idx].loadmore = 0;
                        } else {
                            this.menuList[idx].loadmore = 1;
                        }
                        this.menuList[idx].minid=data.data.content[data.data.content.length-1].id
                    } else {
                        this.menuList[idx].loadmore = 0;
                        this.contentList = [];
                    }
                    this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                    this.menuList[idx].isloadingmoredata = 0;
                } else {
                    this.$message.error(data.msg)
                }
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })

    },
    addLike(itm,idx,index){ //点赞
      let param = {
        innerid:itm.innerid,
        columninnerid:this.menuList.filter(m => m.ischeck)[0].innerid,
      }
      // this.setLoading(true)
        uploadPraiseinfo({
            data: param,
            success: data => {
                this.setLoading(false)
                if (data.code == '000') {
                    this.menuList[index].contentlist[idx].isLike = true
                    this.menuList[index].contentlist[idx].praisecount = data.data.praisecount
                    console.log(this.menuList[index].contentlist[idx])
                } else {
                    this.$message.error(data.msg)
                }
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
    },
    checkMenu(itm, idx, isClick = true) {
      console.log(isClick)
      this.has_mediaReport=false;
      this.is_media=false;
      if(itm.columntype==11 || itm.columntype==12){
        window.open(itm.columnurl,'_blank')
        return
      }
        this.detailType = itm.columnnamenum;
        this.menuList.map(m =>{
            m.ischeck = false
        })
        this.menuList[idx].ischeck = true
        
        if(this.timer){
          clearInterval(this.timer)
        }
        let that = this

        //**********未开始
        if (this.subjectMsg.status === 0){
            // this.$previewRefresh()
            if(this.detailType==1){
                //显示直播未进行
                this.menuId = itm.innerid//当前选择的栏目id
            }
            else if(this.detailType==2 || this.detailType==3){
                this.menuId = itm.innerid; //当前选择的栏目id
                //这些可能提前发布，一次性获取数据 先判断本地是否有数据
                if (
                    !this.menuList[idx].contentlist ||
                    this.menuList[idx].contentlist.length <= 0
                ) {
                    //延迟执行
                    setTimeout(function(){
                    that.getMenuContent(itm,idx,0,0)
                    }, that.clickTime);
                }
            }
        }else if(this.subjectMsg.status === 10){
            this.menuId = itm.innerid; //当前选择的栏目id
            //***********进行中
            //默认有数据，直接定时获取即可
            console.log('this.detailType:'+this.detailType)
            if(this.detailType==1 || this.detailType==2){
                this.timer = setInterval(function() {
                    that.getMenuContent(itm,idx,0,0)
                }, that.refeshtimes);
            }
        }else if(this.subjectMsg.status === 30){
            this.menuId = itm.innerid; //当前选择的栏目id
            //**********已结束 数据放缓存,根据分页信息确定上拉分页
            // console.log('this.menuList[idx].isloadingmoredata:'+this.menuList[idx].isloadingmoredata)
            if (
                !this.menuList[idx].contentlist ||
                this.menuList[idx].contentlist.length <= 0 ||
                this.menuList[idx].isloadingmoredata == 1
            ) {
                //第一次获取 延迟执行
                setTimeout(function(){
                that.getMenuContent(itm,idx,0,0)
                }, that.clickTime);
            }
        } 
    },
    //加载更多
    loadMore(){
              //console.log(this.menuList)
        if(this.is_media) return
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
        let isBtm = document.documentElement.scrollHeight-scrollTop-document.documentElement.clientHeight
        //console.log('底部滚动时间触发点：'+isBtm)
        // alert('scrollHeight:'+document.documentElement.scrollHeight+';scrollTop:'+scrollTop+';clientHeight:'+document.documentElement.clientHeight)
        if(isBtm<=10){
        let xidx,
            that = this
          //加载更多
          this.menuList.map((m,idx) =>{
            if(m.innerid==that.menuId){
              // console.log(m)
              // console.log('isloadingmoredata:'+m.isloadingmoredata+';loadMore:'+m.loadmore)
              if( m.isloadingmoredata==0 && m.loadmore==1 &&
                (m.columntype==1 || m.columntype==2)){
                xidx = idx
                m.isloadingmoredata=1
                if(this.subjectMsg.status==10){
                    this.getMenuContentByPullOnMore(m,xidx)
                }
                else{
                    this.getMenuContent(m,xidx,0,0)
                }
              }
            }
          })
        }
    },
    getImg() {
           
        if (this.detailType === 2) return
        
        let imgReg = /<img.*?(?:>|\/>)/gi,
            // str = '',
            // srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i,
            nullP = '<p><br/></p>'

        this.contentList.map((m, idx)=>{
            m.isLike = false
            m.content = m.content.replace(new RegExp(nullP,'g'),"");//替换掉空标签
            m.imglist = m.content.match(imgReg) || []
            m.imgNum = m.imglist.length
            console.log(idx)
            // if(m.imgNum){
            //     m.content = m.content.replace(/\<( img |img )/g, '<img preview='+m.innerid+' ')
            //     m.content = m.content.replace(
            //         /_s./g,
            //         "."
            //     );
            //     // console.log(m.content)
            // }
        })
    },
    appoint(){
      this.isShowLive = true
       this.getCode()
    },
    //获取图片验证码
    getCode() {
        this.setLoading(true)
        getCode({
            data: {},
            success: data => {
                this.setLoading(false)
                if (data.code == '000') {
                    this.code_url = data.data.base64;
                    this.qrCode = data.data.validateCode;
                } else {
                    this.$message.error(data.msg)
                }
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
      
    },
    //保存预约信息
    saveUserLive(userInfo){
      this.$refs[userInfo].validate((valid) => {
        if (valid) {
        //   this.isLoadingSave = true
          this.is_disabled=false

            this.setLoading(true)
            saveUserLiveInfo({
            data: this.userLiveInfo,
            success: data => {
                this.setLoading(false)
                if (data.code == '000') {
                    
                    // this.isLoadingSave = false
                    this.isShowLive = false
                    // this.$message({
                    //   message: '预约成功~',
                    //   type: 'success'
                    // });
                    this.isShowLiveSuccss=true;
                    this.userLiveInfo = {
                        innerid:this.id,//直播id
                        name:'',//姓名
                        phone:'',//电话
                        reqinfo:'',//需求
                        company:'',//公司
                        code:'',//验证码
                        clienttype:'1',//移动端2,pc1
                    }
                } else {
                    this.$message.error(data.msg)
                }
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
        } else {
          
          return false;
        }
      });
    },
    closeClick(){
      this.isShowLive=false;
      this.isShowLiveSuccss=false;
    },
    //媒体报道
    mediaReport(){
      this.has_mediaReport=true;
      this.is_media=true;
    },
    about(){
      let routeData = this.$router.resolve({
        name: "about",
      });
      window.open(routeData.href, '_blank');
    },
    ...mapActions(['setLoading'])
  },
  mounted () {
     let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if(flag){
        // var _url =  window.location.origin +'/m/live?innerid='+this.leveingId;
        // window.location = _url
            this.$router.push({
                name: 'MImglive',
                query: {liveid: this.$route.query.innerid}
            })
      }
    window.addEventListener('scroll', this.loadMore);
    this.$nextTick(function () {
      this.canvas = document.getElementById('qrccode-canvas')
      this.createQrc()
    })
  },
  computed: {
    ...mapGetters['domainInfo']
  },
  watch:{
   _id(v,t){
     console.log(v,t)
   }
  }
};
</script>
<style>
.img-icon{
  position: absolute;
  left: 8px;
  z-index: 1;
  width: 16px;
  height: 16px;
  top: 12px;
}
.image-item img {
  max-width: 100% !important;
}
.detail-btm strong {
  font-weight: bold !important;
  display: block !important;
  margin: 10px 0;
}
</style>
<style  lang='scss' scoped>
//  @max-width:750px;

.wlive {
    position: relative;
    margin-top: 24px;
    .header {
        width: 100%;
        height: 55px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 8px 0px rgba(0, 18, 41, 0.1);
        .header-wrap{
            height:55px;
            background:rgba(255,255,255,1);
            box-shadow:0px 1px 10px 0px rgba(0, 0, 0, 0.1);
            .header-box{
                img{
                    height: 35px;
                    margin-top:10px;
                }
                width:1160px;
                margin:auto;
                height: 100%;
                background-position: left;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                .user{
                    line-height: 55px;
                    height: 55px;
                    color: #666;
                    font-size: 16px;
                    cursor: pointer;
                    margin-left: 30px;
                    display: inline-block;
                }
                .user:hover{
                    color: #1464C8;
                }
                .user-img-icon{
                    vertical-align: text-bottom;
                }
                .live-desc{
                    background: #1464C8;
                    color: #fff;
                    border-radius: 16px;
                    height: 32px;;
                    line-height: 32px;
                    font-size: 13px;
                    text-align: center;
                    width: 140px;
                    margin-top: 10px;
                    margin-left: 20px;
                    display: inline-block;
                }
            }
        }
    }
    .banner {
        .image {
        width: 1200px;
        height: 550px;
        border-radius: 6px;
        margin: auto;
        margin-bottom: 20px;
        .radius6{border-radius: 6px;}
        .d-see-count{
            top: 20px;
            right: 40px;
            color: #fff;
            text-shadow: 0 0 2px #000;
        }
        }
        .text {
        width: 1200px;
        height: auto;
        // overflow-y: auto;
        margin: auto;
        .suntitle {
            text-align: center;
            margin-bottom: 30px;
            font-size: 26px;
            font-family: PingFangSC-Semibold;
            font-weight:600;
            color: rgba(51, 51, 51, 1);
            line-height: 32px;
        }
        .info {
            text-align: center;
            span {
            margin-left: 12px;
            }
            span:nth-child(2) {
            font-size: 14px;
            color: #1890ff;
            label {
                // background: url("../../../../public/web/title_lock_icon.png")
                //   no-repeat;
                width: 16px;
                height: 16px;
                display: inline-block;
                margin-right: 6px;
                vertical-align: middle;
            }
            }
            span:nth-child(1) {
            font-size: 14px;
            color: #999999;
            label {
                // background: url("../../../../public/web/title_play_icon.png")
                //   no-repeat;
                width: 16px;
                height: 16px;
                display: inline-block;
                margin-right: 6px;
                vertical-align: middle;
            }
            }
            span:nth-child(3) {
            font-size: 14px;
            color: #999999;
            label {
                background: url("./../../../common/images/leveing/web/title_time_icon.png")
                no-repeat;
                width: 16px;
                height: 16px;
                display: inline-block;
                margin-right: 6px;
                vertical-align: middle;
            }
            }
        }
        }
        .pc-ins-content{
        width: 1140px;
        margin: 20px auto;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 16px;
        color: #666;
        line-height: 24px;
        font-family:PingFangSC-Regular;
        font-weight:400;    
        .ins-title{
            color: #333;
            font-size: 16px;
            line-height: 20px;
            font-family: PingFangSC-Semibold;
            font-weight:500;
        }
        }
        .tab {
        margin: auto;
        width: 1200px;
        text-align: center;
        height: 60px;
        line-height: 60px;
        color: #999999;
        span {
            margin-right: 60px;
            font-size: 16px;
            cursor: pointer;
            a{
            color: #999999;
            text-decoration: none;
            }
            .activity {
            color: #333333;
            border-bottom: 2px solid #333333;
            padding-bottom: 20px
            }
            &:hover{
            color: #333333;
            border-bottom: 2px solid #333333;
            padding-bottom: 20px
            }
        }
        .activity {
            color: #333333;
            border-bottom: 2px solid #333333;
            padding-bottom: 20px
        }
        }
    }
    .media-report{
        width: 100%;
        background: #f2f2f2;
        padding-top: 40px;
        padding-bottom: 30px;
        .wrap{
        width: 900px;
        margin: auto;
        background: #fff;
        padding: 0px 60px;
        .media-item{
            border-bottom: 1px solid #DDDDDD;
            padding-bottom: 10px;
            padding-top: 30px;
            .content{
            color: #333333;
            font-size: 24px;
            margin-bottom: 10px;
            a{
                text-decoration: none;
                color: #333333;
                &:hover{
                color: #1890ff
                }
                &:active{
                color: #1890ff
                }
            }
            }
            .time{
            font-size: 12px;
            span{
                margin-right: 10px;
            }
            }
        }
        }
    }
    
    .image-list {
        width: 100%;
        //height:3251px;
        background: rgba(242, 242, 242, 1);
        padding-top: 30px;
        padding-bottom: 30px;
        .image-item {
        width: 60.4%;
        max-width: 1160px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        margin: auto;
        position: relative;
        padding-top: 60px;
        margin-bottom: 30px;
        padding: 30px 0px;
        line-height: 1.25;
        .time {
            position: absolute;
            left: 0px;
            top: 0px;
            span {
            background: url("./../../../common/images/leveing/web/feed_tab_icon.png") no-repeat;
            background-size: contain;
            position: absolute;
            left: 0px;
            top: 0px;
            width: 83px;
            height: 42px;
            display: inline-block;
            font-size: 12px;
            color: #fff;
            line-height: 34px;
            text-align: center;
            }
        }
        .liver {
            position: absolute;
            right: 15px;
            top: 15px;
            color: #999;
            cursor: pointer;
            border: 1px solid #eee;
            padding: 2px 10px;
            border-radius: 4px;
            span {
            background: url("./../../../common/images/leveing/web/index_zan02_icon_default@2x.png") no-repeat;
            vertical-align: text-bottom;
            margin-right: 5px;
            width: 18px;
            height: 18px;
            background-size: contain;
            display: inline-block;
            font-size: 12px;
            color: #fff;
            line-height: 30px;
            text-align: center;
            }
            span.liked{
            background: url("./../../../common/images/leveing/web/index_zan02_icon_selected@2x.png") no-repeat;
            background-size: contain;
            }
        }
        .liked-color{
            color: #2C9AFF;
        }
  
        .detail-btm {
            background-color: white;
            width: 91.4%;
            max-width: 1060px;
            padding: 0 4.3%;
            -webkit-transition: all 0.3s ease 0s;
            -o-transition: all 0.3s ease 0s;
            transition: all 0.3s ease 0s;
            line-height: 26px;
            font-size: 16px;
        }
        
        .detail-btm.img1 img {
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 auto !important;
        }
    
        .detail-btm.img2 img{
            width: calc(50% - 5px) !important;
            height: 320px!important;
        }
        .detail-btm.img2 img:nth-child(2n){
            margin-left: 10px!important;
        }
        .detail-btm.img3 img{
            width: calc(33.3% - 8px) !important;
            margin-right: 8px!important;
            height: 210px!important;
        }
        .detail-btm.img2 img:nth-child(3n){
            margin-right: 0px!important;
        }
        @media screen and (max-width: 1365px){
            .detail-btm.img2 img{
                height: 200px!important;
            }
            .detail-btm.img3 img{
                height: 90px!important;
            }
        }    
        @media screen and (width: 1366px){
            .detail-btm.img2 img{
                height: 250px!important;
            }
            .detail-btm.img3 img{
                height: 160px!important;
            }
        }
        @media screen and ( min-width: 1367px ) and (max-width: 1600px){
            .detail-btm.img2 img{
                height: 280px!important;
            }
            .detail-btm.img3 img{
                height: 180px!important;
            }
        }
        .text-item {
            width: 87.5%;
            margin: auto;
            // position: relative;
            line-height: 1.5;
            img {
                width: 100%;
                height: 100%;
            }
            .poster-image {
                width: 100%;
            }
        }
    }
}
.poster-wrap {
    width: 60.4%;
    max-width: 1366px;
    margin: 30px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .image-item {
        width: 260px;
        height: 460px;
        padding-top: 0px;
        box-shadow: 2px 2px 10px 0px rgba(0, 25, 57, 0.14);
        margin: 0px;
        margin-bottom: 20px;
        // margin-right: 20px;
        img{
        width: 100%;
        height: 100%;
        }
    }
    .no-result {
        background: url("./../../../common/images/leveing/web/no-live.png") #f2f2f2 no-repeat;
        height: 400px;
        background-position: 50% 25%;
        position: relative;
        text-align: center;
        width: 100%;
        span {
        position: absolute;
        top: 240px;
        margin-left: -40px;
        color: #999;
        }
    }
}
   
.no-result {
    background: url("./../../../common/images/leveing/web/no-live.png") #f2f2f2 no-repeat;
    height: 400px;
    background-position: 50% 25%;
    position: relative;
    text-align: center;
    span {
      position: absolute;
      top: 240px;
      margin-left: -40px;
      color: #999;
    }
}
.appoint-wrap{
    background:rgba(0,0,0,1);
    opacity:0.8;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
   //background: #999
}

.dialog-cont{
    width: calc(100% - 40px);
    max-width: 400px;
    margin-left: 10px;
    padding: 0 10px;
    border-radius: 10px;
    z-index: 26;
    min-height: 260px;
    background: #fff;
    position: fixed;
    bottom: 10px;
    position: fixed;
    top: 50%;
    margin-top: -200px;
    left: 50%;
    margin-left: -200px;
    max-height: 500px;
    .logo-div{
      width: 80px;
      height: 80px;
      line-height: 80px;
      margin-top: -50px;
      background: #fff;
      padding: 10px;
      border-radius: 50%;
      -webkit-box-shadow: 0 0 5px #ccc;
      box-shadow: 0 0 5px #ccc;
      position: absolute;
      left: 50%;
      margin-left: -45px;
      img{
        width: 50px;
        height: 40px;
        margin-top: 16px;
      }
    }
    .dialog-logo{
      width: 30px;
      height: 30px;
      margin-top: 10px;
      cursor: pointer;
    }
    .close{
      position: absolute;
      top: -48px;
      right: 0px;
      i{
        font-size: 40px;
      }
    }
    .media-tit{
      color: #333;
      font-weight: bold;
      font-size: 18px;
      margin: 70px auto 20px;
    }
    .list{
      max-height: 220px;
      overflow-y: scroll;
      margin-bottom: 50px;
    }
    .a-item{
      padding-bottom: 6px;
      margin-bottom: 6px;
      border-bottom:1px solid #eee;
    }
    .title{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 26px;
    }
    .btm-hide{
      position: absolute;
      bottom: 0;
      line-height: 30px;
      background: #fff;
      text-align: center;
      padding: 10px 0;
      width: calc(100% - 20px);
    }
    .code-img{
      width: 170px;
      height: 170px;
      margin: 20px auto;
    }
}
.appoint-wrap-success{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background:#000;
    opacity:.8;
}
.dialog-cont-success{
      width:416px;
      height:394px;
      background:rgba(255,255,255,1);
      border-radius:8px;
      margin-left: -218px;
      .success-icon{
        margin-top: 95px;
        text-align: center;
        margin-bottom: 20px;
      }
      .success-text{
        height:60px;
        font-size:50px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:60px;
        text-align: center;
      }
      .success-footer{
        text-align: center;
        margin-top: 40px;
        color: #666;

      }
      .phone{
        text-align: center;
        margin-top: 4px;
        color: #666;
        span{
          color: #1890ff
        }
      }
      .cancel-icon{
        position: absolute;
        right: 0px;
        top: -40px;
        cursor: pointer;
        img{
          width: 30px;
          height: 30px;
        }
      }
    }
  .footer {
    color: #fff;
    height: 60px;
    background: #283746;
    line-height: 60px;
    text-align: center;
  }
}
</style>

<style lang='scss' scoped>
.wlive .detail-btm p {
  padding: 10px 0 0px 0 !important;
  font-family:PingFangSC-Regular!important;
  font-weight:400;
  font-size: 16px!important;
  color: #333!important;
}
.wlive .detail-btm p span{
  font-family:PingFangSC-Regular!important;
  font-weight:400;
  font-size: 16px!important;
}
.tc{
  text-align: center;
  .el-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
    padding: 10px 40px;
    border-radius: 12px;
}
}
.ybtn{
  position: relative;
  left: 50%;
  margin-left: -49px
}
.ft12{
	font-size: 12px;
}
.ft14{
	font-size: 14px;
}
.ft16{font-size: 16px;}
.mt20{
	margin-top: 20px;
}
.mb20{margin-bottom: 20px;}
.pt50{
	padding-top: 35px;
}
.pb20{
  padding-bottom: 20px;
}
.mr10{
	margin-right: 10px;
}
.mr20{
	margin-right: 20px;
}
.pr{
	position: relative;
}
.pa{
	position: absolute;
}
.code-qr-img{
  width: 110px;
  height: 38px;
  float: right;
}
.code-qr-img img{
  width: 100%;
  height: 100%;
  position: relative;
  top: -39px;
  right: 10px;;
}
.detail-btm img{
    max-width: 100%!important;
    margin-bottom: 5px;
 }
 .el-popover{
    .wlive-pr-code-upload{
        text-align: center;
        .pr-code-text{
            margin-top: 10px;
        }
        img{
            width: 120px;
            height: 125px;
        }
    }
}
.viewer-backdrop {
  background-color: rgba(0, 0, 0, 1);
}
</style>
